module.exports = {
        srcSet: __webpack_public_path__ + "static/media/warteliste-mobile-640.8e10d9e5.webp"+" 640w",
        images: [{path: __webpack_public_path__ + "static/media/warteliste-mobile-640.8e10d9e5.webp",width: 640,height: 349}],
        src: __webpack_public_path__ + "static/media/warteliste-mobile-640.8e10d9e5.webp",
        toString: function(){return __webpack_public_path__ + "static/media/warteliste-mobile-640.8e10d9e5.webp"},
        
        width: 640,
        height: 349
      }